import { render, staticRenderFns } from "./ScreenFull.vue?vue&type=template&id=2a2195b6&scoped=true&"
import script from "./ScreenFull.vue?vue&type=script&lang=js&"
export * from "./ScreenFull.vue?vue&type=script&lang=js&"
import style0 from "./ScreenFull.vue?vue&type=style&index=0&id=2a2195b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2195b6",
  null
  
)

export default component.exports